import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";
import {toDailyUpdateReportRequest} from "./dailyUpdateReportFilters";

export const ReportApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchDailyUpdateReportApi: build.query({
            query: (query) => ({
                url: "/ajax/daily-update-report",
                method: "POST",
                body: toDailyUpdateReportRequest(query),
                headers: getAuthorizationHeader(),
            }),
            providesTags: ["report"],
            async onQueryStarted(_, {queryFulfilled}) {
                await handleQueryError(queryFulfilled);
            },
        }),
        exportDailyUpdateReportData: build.query({
            query: (query) => ({
                url: "/export/daily-update-report",
                method: "POST",
                body: toDailyUpdateReportRequest(query),
                headers: getAuthorizationHeader(),
                responseHandler: async (response: Response) => {
                    if (!response.ok) {
                        return response.json();
                    }
                    downloadFile(await response.blob(), getFileName("daily-update-report", ".csv"));
                    return {success: true};
                },
            }),
            async onQueryStarted(_, {queryFulfilled}) {
                await handleQueryError(queryFulfilled);
            },
        }),
        searchCountyReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/county-reports?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchTurnAroundReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/turn-around-reports?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchAggUserEfficReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/aggregate-user-efficiency-reports?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchDetailedUserEfficReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/detailed-user-efficiency-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchRevenueReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/revenue-reports?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchAutoVsManualReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/auto-manual-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchAccountsReceivableReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/accounts-receivable-reports?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchFullfillmentCandidateReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/fulfillment-candidate-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchFullfillmentCustomerReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/fulfillment-customer-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getFullfillmentCustomerbyTenant: build.query({
            query: (tenant) => {
                // Serialize the data to query parameters
                return {
                    url: `/ajax/get-all-fulfillment-customer-tenant/${tenant}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchDailyOrderCountReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/fulfillment-candidate-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchProductAssignmentReportApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/product-assignment-report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['report'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getReportApiById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['reportById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportCountyReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/county-reports?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("county-reports"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAggregateUserEfficencyReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/aggregate-user-efficiency-reports?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("aggregate-user-efficiency-reports"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportDetailedUserEfficencyReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/detailed-user-efficiency-report?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("detailed-user-efficiency-reports"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAutoVsManualReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/auto-manual-report?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("auto-manual-report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAccountsRecievableReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/accounts-receivable-reports-csv?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("accounts-receivable-report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportFulfillmentCandidateReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/fulfillment-candidate-report?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("fulfillment-candidate-report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportFulfillmentCustomerReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/fulfillment-customer-report?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("fulfillment-customer-report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportTurnAroundReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/turn-around-reports?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("turn_around_report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportDailyOrderReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/daily-order-count?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("daily-order-count", ".xlsx"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportProductAssignmentReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/product-assignment-report?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("product-assignment-report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportRevenueReportData: build.query({
            query: (query) => {
                return {
                    url: `/export/revenue-reports?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("revenue_report"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});


export const {
    useSearchDailyUpdateReportApiQuery,
    useLazyExportDailyUpdateReportDataQuery,
    useGetReportApiByIdQuery,
    useSearchCountyReportApiQuery,
    useLazyExportCountyReportDataQuery,
    useSearchTurnAroundReportApiQuery,
    useLazyExportTurnAroundReportDataQuery,
    useSearchRevenueReportApiQuery,
    useLazyExportRevenueReportDataQuery,
    useSearchAggUserEfficReportApiQuery,
    useSearchDetailedUserEfficReportApiQuery,
    useSearchAutoVsManualReportApiQuery,
    useSearchAccountsReceivableReportApiQuery,
    useSearchFullfillmentCandidateReportApiQuery,
    useSearchFullfillmentCustomerReportApiQuery,
    useSearchDailyOrderCountReportApiQuery,
    useSearchProductAssignmentReportApiQuery,
    useLazyGetFullfillmentCustomerbyTenantQuery,
    useLazyExportAggregateUserEfficencyReportDataQuery,
    useLazyExportDetailedUserEfficencyReportDataQuery,
    useLazyExportAutoVsManualReportDataQuery,
    useLazyExportAccountsRecievableReportDataQuery,
    useLazyExportFulfillmentCandidateReportDataQuery,
    useLazyExportFulfillmentCustomerReportDataQuery,
    useLazyExportDailyOrderReportDataQuery,
    useLazyExportProductAssignmentReportDataQuery
} = ReportApi;
